import {Model} from '@nozbe/watermelondb';
import {PAYMENT_SCHEMA} from '../schema';
import {date, field, relation, text} from '@nozbe/watermelondb/decorators';

export default class Payment extends Model {
    static table = PAYMENT_SCHEMA;

    static associations = {
        business: {type: 'belongs_to', key: 'business_id'},
        customer: {type: 'belongs_to', key: 'customer_id'},
        order: {type: 'belongs_to', key: 'order_id'},
    };

    @text('payment_method') payment_method;
    @text('card_number') card_number;
    @field('amount') amount;
    @text('status') status;
    @text('type') type;

    @date('completed_at') completed_at;
    @date('expiry_date') expiry_date;
    @date('started_at') started_at;
    @date('created_at') created_at;

    @relation('business', 'business_id') business;
    @relation('customer', 'customer_id') customer;
    @relation('order', 'order_id') order;
}
